import { useState } from 'react'
import { Nav, Form, Button, Table } from 'react-bootstrap'
import { Plus, X, Bold, Italic, List, Quote, Link } from 'lucide-react'
import Swal from 'sweetalert2'

export default function EmailInvitesSection() {
  const [activeTab, setActiveTab] = useState('Send Invites')
  const [recipients, setRecipients] = useState([{ name: '', email: '' }])

  // Add new recipient
  const addRecipient = () => {
    setRecipients([...recipients, { name: '', email: '' }])
  }

  // Remove a recipient
  const removeRecipient = (index) => {
    setRecipients(recipients.filter((_, i) => i !== index))
  }

  // Update recipient info
  const updateRecipient = (index, field, value) => {
    const newRecipients = [...recipients]
    newRecipients[index] = { ...newRecipients[index], [field]: value }
    setRecipients(newRecipients)
  }

  // Send email invites
  const [email, setEmail] = useState('')

  const sendInvite = async () => {
    const token = localStorage.getItem('jwttoken') // Retrieve token

    if (!token) {
      Swal.fire('Error!', 'You are not authenticated!', 'error')
      return
    }

    for (const recipient of recipients) {
      if (!recipient.email.trim()) {
        Swal.fire('Error!', 'Each recipient must have an email!', 'error')
        return
      }

      try {
        const response = await fetch(
          'https://tdtlworld.com/dss-kaas-backend/socialapp/send-invite/',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ email: recipient.email }),
          }
        )

        const data = await response.json()

        if (response.ok) {
          Swal.fire(
            'Success!',
            `Invitation sent to ${recipient.email}`,
            'success'
          )
        } else {
          Swal.fire(
            'Error!',
            data.error || `Failed to send invite to ${recipient.email}`,
            'error'
          )
        }
      } catch (error) {
        console.error('Error:', error)
        Swal.fire(
          'Error!',
          `Failed to send invite to ${recipient.email}`,
          'error'
        )
      }
    }
  }

  // Tab content rendering
  const renderContent = () => {
    if (activeTab === 'Send Invites') {
      return (
        <>
          <h4 className='mb-3'>Send Invites</h4>
          <p className='text-muted mb-4'>
            Invite non-members to create an account. They will receive an email
            with a link to register.
          </p>

          <div className='border rounded-3 p-4 mb-4'>
            <div className='row mb-3'>
              <div className='col-6'>
                <h6>Recipient Name</h6>
              </div>
              <div className='col-6'>
                <h6>Recipient Email</h6>
              </div>
            </div>

            {recipients.map((recipient, index) => (
              <div key={index} className='row mb-2 align-items-center'>
                <div className='col-6'>
                  <Form.Control
                    type='text'
                    value={recipient.name}
                    onChange={(e) =>
                      updateRecipient(index, 'name', e.target.value)
                    }
                    className='bg-light border-0'
                    placeholder='Enter name'
                  />
                </div>
                <div className='col-6 d-flex align-items-center gap-2'>
                  <Form.Control
                    type='email'
                    value={recipient.email}
                    onChange={(e) =>
                      updateRecipient(index, 'email', e.target.value)
                    }
                    className='bg-light border-0'
                    placeholder='Enter email'
                  />
                  {recipients.length > 1 && (
                    <Button
                      variant='link'
                      className='text-muted p-0'
                      onClick={() => removeRecipient(index)}
                    >
                      <X size={20} />
                    </Button>
                  )}
                </div>
              </div>
            ))}

            {/* <div className="mt-3">
              <Button
                variant="primary"
                className="rounded-circle p-0"
                style={{ width: "32px", height: "32px" }}
                onClick={addRecipient}
              >
                <Plus size={16} />
              </Button>
            </div> */}
          </div>

          {/* <p className="text-muted mb-3">
            Customize the text of the invitation email. A link to register will be sent with the email.
          </p>

          <div className="border rounded-3 mb-4">
            <div className="border-bottom p-2">
              <Button variant="link" className="text-muted p-1">
                <Bold size={16} />
              </Button>
              <Button variant="link" className="text-muted p-1">
                <Italic size={16} />
              </Button>
              <Button variant="link" className="text-muted p-1">
                <List size={16} />
              </Button>
              <Button variant="link" className="text-muted p-1">
                <Quote size={16} />
              </Button>
              <Button variant="link" className="text-muted p-1">
                <Link size={16} />
              </Button>
            </div>
            <div
              className="p-3"
              contentEditable
              suppressContentEditableWarning
              role="textbox"
              aria-label="Invitation message"
            >
              You have been invited to join the <a href="#" className="text-primary text-decoration-none">TDTL LMS</a> community.
            </div>
          </div> */}

          <Button
            variant='primary'
            size='lg'
            className='px-4'
            onClick={sendInvite}
          >
            Send Invites
          </Button>
        </>
      )
    }

    return (
      <>
        {/* <h4 className="mb-3">Sent Invites</h4>
        <p className="text-muted mb-4">
          You have sent invitation emails to the following people:
        </p>

        <div className="border rounded-3 mb-4">
          <Table className="mb-0">
            <thead>
              <tr>
                <th className="border-0">Name</th>
                <th className="border-0">Email</th>
                <th className="border-0">Invited</th>
                <th className="border-0">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan={4} className="text-muted">
                  You haven't sent any invitations yet.
                </td>
              </tr>
            </tbody>
          </Table>
        </div> */}
      </>
    )
  }

  return (
    <div className='card shadow-sm'>
      <div className='card-body p-0'>
        <Nav className='border-bottom gap-4 px-4'>
          {['Send Invites'].map((tab) => (
            <Nav.Item key={tab}>
              <Nav.Link
                onClick={() => setActiveTab(tab)}
                className={`py-3 px-1 border-bottom border-3 ${
                  activeTab === tab
                    ? 'border-primary text-primary'
                    : 'border-transparent text-muted'
                }`}
              >
                {tab}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>

        <div className='p-4'>
          {renderContent()}
          <div className='text-muted small mt-4'>© 2025 - Vetrina Healthcare Pvt Ltd</div>
        </div>
      </div>
    </div>
  )
}
